// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__wKULS","options":"AnswerScale_options__GUd2I","selected":"AnswerScale_selected__99DBH"};